import { API } from 'aws-amplify';
import awsUtils from 'utils/awsUtils';
import { IHireCompanyUsageConstraints } from 'types/HireCompany';

const apiName = awsUtils.getAPIName();

async function updateCompanyUsageConstraint(data: Partial<IHireCompanyUsageConstraints>) {
  const authHeader = await awsUtils.getAuthHeader();
  const path = `/outdefine_hire/company_usage_constraints/`;
  const myInit = {
    headers: { ...authHeader },
    body: JSON.stringify(data),
  };
  const result = await API.put(apiName, path, myInit);
  return result?.constraints;
}
const HireCompanyUsageConstraintsApi = { updateCompanyUsageConstraint };

export default HireCompanyUsageConstraintsApi;